import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { SizeProps } from 'styled-system';
import { borderRadius, color, fontSize, lineHeight, size } from 'styled-system';

import type { FillProps } from '../../theme/system-types';
import type { ThemeDimensionsProps } from '../../theme/system-utilities';
import { cursor, fill, textDecoration } from '../../theme/system-utilities';
import type { ButtonWithHTMLAttrsProps } from '../Button';
import { Button } from '../Button';
import Icon from '../Icon';

const UnstyledStyledButton = styled(Button)<any>`
  ${color};
  ${fontSize};
  ${lineHeight};
  ${textDecoration};
  ${cursor};
  ${borderRadius};
`;

const StyledButton = (props: ComponentProps<typeof UnstyledStyledButton>) => (
  <UnstyledStyledButton
    kind="bare"
    color="sys.neutral.border.hover"
    fontSize="fs_14"
    lineHeight="lh_20"
    mb="sp_16"
    cursor="pointer"
    borderRadius="medium"
    {...props}
  />
);

const UnstyledArrowRightIcon = styled(Icon)<SizeProps & FillProps & ThemeDimensionsProps>`
  ${size};
  ${fill};
`;

const ArrowRightIcon = (props: ComponentProps<typeof UnstyledArrowRightIcon>) => (
  <UnstyledArrowRightIcon
    size={['20px', null, null, '24px']}
    fill="sys.neutral.border.hover"
    {...props}
  />
);

const ArrowButton = ({ children, ...props }: ButtonWithHTMLAttrsProps) => (
  <StyledButton {...props}>
    {children} <ArrowRightIcon name="arrowRight" fill={props.fill} />
  </StyledButton>
);

export default ArrowButton;
